import { bootstrapApplication } from '@angular/platform-browser';
import { MSAL_INSTANCE } from '@azure/msal-angular';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { environment } from '../environments/environment';
import { MSALInstanceFactory } from './app/auth-config';

// Create and fully initialize MSAL before Angular bootstraps, so no guard,
// interceptor, or root service can call a token API before initialize() completes.
const msalInstance = MSALInstanceFactory();

msalInstance
	.initialize()
	.then(() =>
		bootstrapApplication(AppComponent, {
			...appConfig,
			providers: [
				...appConfig.providers,
				{ provide: MSAL_INSTANCE, useValue: msalInstance },
			],
		}),
	)
	.catch((err: unknown) => {
		if (environment.name != 'production') {
			console.error(err);
		}
	});
